import { render, staticRenderFns } from "./SalesByVariant.vue?vue&type=template&id=21ec229d&scoped=true"
import script from "./SalesByVariant.vue?vue&type=script&lang=js"
export * from "./SalesByVariant.vue?vue&type=script&lang=js"
import style0 from "./SalesByVariant.vue?vue&type=style&index=0&id=21ec229d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ec229d",
  null
  
)

export default component.exports